import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Radio from '@mui/material/Radio';
import RadioGroupMUI from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';
import { ReactElement, ReactNode } from 'react';

import {
  AllocationMode,
  allocationModeOptions,
} from '~/ui/pages/ActTeam/reusable/ClientAllocationForm/constants/allocationMode';
import { useEditClientAllocationContext } from '~/ui/pages/ActTeam/reusable/ClientAllocationForm/EditClientAllocation/context/EditClientAllocationContext';

import styles from './EditAllocationFormLayout.module.scss';

interface IProps {
  title: string;
  isRestored: boolean;
  children: ReactNode;
}

const EditAllocationFormLayout = ({ title, isRestored, children }: IProps): ReactElement => {
  const { allocationMode, setAllocationMode, showAllocationModeRadio } =
    useEditClientAllocationContext();

  return (
    <Paper>
      <div className={styles.wrapper}>
        <Grid container spacing={4}>
          <Grid
            className={styles.titleRow}
            size={{
              sm: 12,
            }}
          >
            <Typography variant="subtitle1" className={styles.assignedClientsTitle}>
              {title}
            </Typography>
            {showAllocationModeRadio && (
              <RadioGroupMUI
                row
                value={allocationMode}
                onChange={(_, value) => setAllocationMode(value as AllocationMode)}
              >
                {allocationModeOptions.map(option => (
                  <FormControlLabel
                    key={option.value}
                    value={option.value}
                    label={option.label}
                    control={<Radio color="primary" size="small" />}
                  />
                ))}
              </RadioGroupMUI>
            )}
          </Grid>
        </Grid>

        {isRestored && (
          <div className={styles.formWrapper} data-menu-scroll-container>
            {children}
          </div>
        )}
      </div>
    </Paper>
  );
};

export default EditAllocationFormLayout;
